<!-- eslint-disable -->
<template>
  <transition name="crm-modal-fade">
    <div
      v-if="visible"
      class="crm-modal-backdrop"
      @mousedown.self="$emit('close')"
    >
      <div class="crm-modal-card crm-activity-modal">
        <!-- Header -->
        <div class="crm-modal-header">
          <div class="crm-modal-header__left">
            <div class="crm-modal-header__icon">
              <feather-icon :icon="headerIcon" size="18" />
            </div>
            <div>
              <h3 class="crm-modal-header__title">{{ titleText }}</h3>
              <p class="crm-modal-header__subtitle">{{ card ? card.title : 'Sales Follow-up Workflow' }}</p>
            </div>
          </div>
          <button class="crm-modal-close" @click="$emit('close')">
            <feather-icon icon="XIcon" size="18" />
          </button>
        </div>

        <!-- Body -->
        <div class="crm-modal-body">
          <!--
            Karim, 7 Sep: "the activity email should send email from the user
            email via google api same used in quotation, but just he can
            select the to, cc, subject, body and send — also the user email
            in google have signature that is sent auto." Also (7 Sep, later):
            "sales can be able to upload attachment with email send... email
            will be send on date selected there should be also a send now
            option." Shown instead of the normal Call/Visit/Meeting flow
            whenever the activity being logged IS an email — either because
            the rep opened the modal via "Send Email" directly
            (startInEmailMode) or because they're completing a previously
            scheduled Email activity.
          -->
          <!--
            Karim, 7 Sep: "if he wanted to lost, then there is no activity or
            next activity there. He must add the lost reason. If he wanted to
            won, he must add the related application number on the system."
            Lost/Won are outcomes, not another activity to schedule — shown
            whenever the stage being moved TO is one of the two, whether that
            move came from dragging the card or the toolbar (this reuses the
            same reason list PipelineCRM.vue's bulk-lost flow already shows).
          -->
          <template v-if="isLostMove">
            <div class="crm-form-group">
              <label class="crm-form-label">Reason (required)</label>
              <select v-model="lostReasonSelect" class="crm-input">
                <option value="">— select a reason —</option>
                <option v-for="r in lostReasons" :key="r" :value="r">{{ r }}</option>
              </select>
            </div>
            <div v-if="lostReasonSelect === 'Other'" class="crm-form-group mb-0">
              <label class="crm-form-label">Say what happened</label>
              <textarea v-model="lostReasonOther" class="crm-textarea" rows="3"></textarea>
            </div>
            <p class="crm-field-hint">No next activity — this closes the opportunity out.</p>
          </template>

          <template v-else-if="isWonMove">
            <div class="crm-form-group mb-0">
              <label class="crm-form-label">Application / Request Number (required)</label>
              <input
                v-model="requestCode"
                type="text"
                class="crm-input"
                placeholder="e.g. the request code from the ERP"
                @input="onRequestCodeInput"
              />
              <p v-if="requestLookup.loading" class="crm-field-hint crm-field-hint--tight">Checking…</p>
              <p v-else-if="requestLookup.matched" class="crm-field-hint crm-field-hint--tight crm-field-hint--ok">
                <feather-icon icon="CheckIcon" size="11" class="mr-1" />
                Matched: {{ requestLookup.matched.certificateName || requestLookup.matched.requestCode }}
              </p>
              <p v-else-if="requestLookup.error" class="crm-field-hint crm-field-hint--tight crm-field-hint--error">
                {{ requestLookup.error }}
              </p>
            </div>
          </template>

          <template v-else-if="isEmailCompose">
            <div class="crm-form-group">
              <label class="crm-form-label">To</label>
              <input v-model="emailTo" type="text" class="crm-input" placeholder="client@company.com, another@company.com" />
              <p class="crm-field-hint crm-field-hint--tight">Comma-separate multiple addresses.</p>
            </div>
            <div class="crm-form-group">
              <label class="crm-form-label">Cc <span class="text-muted font-weight-normal">(optional)</span></label>
              <input v-model="emailCc" type="text" class="crm-input" placeholder="" />
            </div>
            <div class="crm-form-group">
              <label class="crm-form-label">Subject</label>
              <input v-model="emailSubject" type="text" class="crm-input" />
            </div>
            <div class="crm-form-group">
              <label class="crm-form-label">Body</label>
              <textarea v-model="emailBody" class="crm-textarea" rows="6"></textarea>
              <p class="crm-field-hint crm-field-hint--tight">Your Gmail signature is added automatically — no need to type one.</p>
            </div>

            <div class="crm-form-group">
              <label class="crm-form-label">Attachments</label>
              <div class="crm-attach-list" v-if="emailAttachments.length">
                <span v-for="(file, idx) in emailAttachments" :key="idx" class="crm-attach-chip">
                  <feather-icon icon="PaperclipIcon" size="11" class="mr-1" />
                  {{ file.name }}
                  <button type="button" class="crm-attach-chip__remove" @click="removeAttachment(idx)">
                    <feather-icon icon="XIcon" size="10" />
                  </button>
                </span>
              </div>
              <label class="crm-btn crm-btn--ghost crm-attach-btn">
                <feather-icon icon="PaperclipIcon" size="13" />
                <span>Attach file</span>
                <input type="file" multiple class="d-none" @change="onFilesSelected" />
              </label>
            </div>

            <div class="crm-form-group mb-0">
              <label class="crm-form-label">When</label>
              <div class="d-flex gap-2 mb-2">
                <button
                  type="button"
                  class="crm-preset-btn"
                  :class="{ 'crm-preset-btn--active': emailSendMode === 'now' }"
                  @click="emailSendMode = 'now'"
                >
                  <feather-icon icon="SendIcon" size="12" class="mr-1" /> Send Now
                </button>
                <button
                  type="button"
                  class="crm-preset-btn"
                  :class="{ 'crm-preset-btn--active': emailSendMode === 'schedule' }"
                  @click="emailSendMode = 'schedule'"
                >
                  <feather-icon icon="CalendarIcon" size="12" class="mr-1" /> Send on date
                </button>
              </div>
              <div v-if="emailSendMode === 'schedule'" class="crm-form-row">
                <div class="crm-form-group flex-grow-1 mb-0">
                  <flat-pickr v-model="emailSendDate" class="crm-input" :config="dateConfig" placeholder="Select date..." />
                </div>
                <div class="crm-form-group flex-grow-1 mb-0">
                  <input v-model="emailSendTime" type="time" class="crm-input" />
                </div>
              </div>
            </div>
          </template>

          <template v-else>
          <!-- Step 1: Complete Current Activity (if any) -->
          <div v-if="currentActivity" class="crm-activity-step mb-4">
            <div class="crm-activity-step__header">
              <span class="crm-step-badge crm-step-badge--done">1</span>
              <h4 class="crm-step-title">Complete Current Activity</h4>
            </div>
            <div class="crm-current-activity-box p-3 rounded bg-light border mb-2">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span class="font-weight-bold text-sm text-primary">
                  <feather-icon :icon="getActivityIcon(currentActivity.type)" size="14" class="mr-1" />
                  {{ currentActivity.type }}
                </span>
                <span class="text-xs text-muted">{{ currentActivity.dueDate }}</span>
              </div>
              <p class="mb-0 text-xs text-secondary">{{ currentActivity.note || 'No notes specified.' }}</p>
            </div>
            <div class="form-group mb-0">
              <label class="crm-form-label">Activity Outcome / Result Notes</label>
              <textarea
                v-model="outcomeNote"
                class="crm-textarea"
                rows="2"
                placeholder="What happened during this call/email/visit? (e.g., Client agreed to proceed...)"
              ></textarea>
            </div>
          </div>

          <!-- Step 2: Schedule Next Activity -->
          <div class="crm-activity-step">
            <div class="crm-activity-step__header">
              <span class="crm-step-badge crm-step-badge--next">2</span>
              <h4 class="crm-step-title">Schedule Next Activity</h4>
              <!--
                Karim, 7 Sep: "for the next activity there should be button for
                none or no next activity." The form used to force a type+date
                on every save — there was no way to just log what happened and
                stop, e.g. a lead that turned out to be dead.
              -->
              <button
                type="button"
                class="crm-btn crm-btn--ghost crm-none-btn"
                :class="{ 'crm-none-btn--active': noNextActivity }"
                @click="noNextActivity = !noNextActivity"
              >
                <feather-icon icon="XCircleIcon" size="14" />
                <span>{{ noNextActivity ? 'No next activity' : 'None' }}</span>
              </button>
            </div>

            <template v-if="!noNextActivity">
              <!-- Activity Type Selector Buttons -->
              <div class="crm-form-group mb-3">
                <label class="crm-form-label">Select Next Activity Type</label>
                <div class="crm-type-grid">
                  <button
                    v-for="type in activityTypes"
                    :key="type.name"
                    type="button"
                    class="crm-type-btn"
                    :class="{ 'crm-type-btn--active': nextType === type.name }"
                    @click="nextType = type.name"
                  >
                    <feather-icon :icon="type.icon" size="16" />
                    <span>{{ type.name }}</span>
                  </button>
                </div>
              </div>

              <!-- Quick Date Preset Buttons -->
              <div class="crm-form-group mb-3">
                <label class="crm-form-label">Due Date Presets</label>
                <div class="d-flex gap-2">
                  <button
                    v-for="preset in datePresets"
                    :key="preset.label"
                    type="button"
                    class="crm-preset-btn"
                    :class="{ 'crm-preset-btn--active': selectedPreset === preset.days }"
                    @click="applyDatePreset(preset.days)"
                  >
                    {{ preset.label }}
                  </button>
                </div>
              </div>

              <!-- Custom Date & Time Inputs -->
              <div class="crm-form-row mb-3">
                <div class="crm-form-group flex-grow-1">
                  <label class="crm-form-label">Date</label>
                  <flat-pickr
                    v-model="nextDate"
                    class="crm-input"
                    :config="dateConfig"
                    placeholder="Select due date..."
                  />
                </div>
                <div class="crm-form-group flex-grow-1">
                  <label class="crm-form-label">Time</label>
                  <input
                    v-model="nextTime"
                    type="time"
                    class="crm-input"
                  />
                </div>
              </div>

              <!-- Next Activity Notes -->
              <div class="crm-form-group mb-0">
                <label class="crm-form-label">Next Action Instructions / Notes</label>
                <textarea
                  v-model="nextNote"
                  class="crm-textarea"
                  rows="2"
                  placeholder="What needs to be done? (e.g. Call back to confirm quotation receipt...)"
                ></textarea>
              </div>
            </template>
            <p v-else class="crm-field-hint">
              This will be logged as done with nothing scheduled after it.
            </p>
          </div>
          </template>
        </div>

        <!-- Footer -->
        <div class="crm-modal-footer">
          <button type="button" class="crm-btn crm-btn--ghost" @click="$emit('close')">Cancel</button>
          <button
            v-if="isLostMove"
            type="button"
            class="crm-btn crm-btn--danger"
            :disabled="!resolvedLostReason"
            @click="handleSave"
          >
            <feather-icon icon="XCircleIcon" size="15" />
            Mark Lost
          </button>
          <button
            v-else-if="isWonMove"
            type="button"
            class="crm-btn crm-btn--primary"
            :disabled="!requestLookup.matched"
            @click="handleSave"
          >
            <feather-icon icon="CheckCircleIcon" size="15" />
            Mark Won
          </button>
          <button
            v-else-if="isEmailCompose"
            type="button"
            class="crm-btn crm-btn--primary"
            :disabled="!canSendEmail"
            @click="handleSendEmail"
          >
            <feather-icon :icon="emailSendMode === 'now' ? 'SendIcon' : 'CalendarIcon'" size="15" />
            {{ emailSendMode === 'now' ? 'Send Email' : 'Schedule Email' }}
          </button>
          <button
            v-else
            type="button"
            class="crm-btn crm-btn--primary"
            :disabled="!noNextActivity && (!nextDate || !nextType)"
            @click="handleSave"
          >
            <feather-icon icon="CheckCircleIcon" size="15" />
            {{ noNextActivity ? 'Save' : 'Save & Schedule Next' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'
import { LOST_REASONS } from '../pipeline-constants'

// Karim, 7 Sep: pre-fill the next-activity suggestion per stage instead of
// always defaulting to a blank "+3 days / Call" — mirrors the wording the
// backend's own stage sub_stages already use, so this is only a suggestion
// the rep can still edit or clear with "None", never a hard requirement.
const STAGE_NEXT_ACTIVITY = {
  proposal: { type: 'Follow-up', note: 'Check for proposal response', days: 3 },
  responded: { type: 'Call', note: 'Schedule call / visit', days: 2 },
  negotiation: { type: 'Meeting', note: 'Follow up on negotiation', days: 3 },
  quotation: { type: 'Follow-up', note: 'Follow up on quotation', days: 3 }
}

export default {
  name: 'ActivityModal',
  components: {
    flatPickr
  },
  props: {
    visible: { type: Boolean, required: true },
    card: { type: Object, default: null },
    targetStage: { type: String, default: null },
    // Karim, 7 Sep: opened directly from a "Send Email" quick-action (no
    // scheduled activity to complete first) — go straight to compose.
    startInEmailMode: { type: Boolean, default: false }
  },
  data() {
    return {
      outcomeNote: '',
      noNextActivity: false,
      nextType: 'Call',
      nextDate: moment().add(3, 'days').format('YYYY-MM-DD'),
      nextTime: '10:00',
      nextNote: '',
      selectedPreset: 3,

      // Email compose
      emailTo: '',
      emailCc: '',
      emailSubject: '',
      emailBody: '',
      emailAttachments: [],
      emailSendMode: 'now',
      emailSendDate: moment().format('YYYY-MM-DD'),
      emailSendTime: '09:00',

      // Lost / Won outcome capture
      lostReasonSelect: '',
      lostReasonOther: '',
      lostReasons: LOST_REASONS,
      requestCode: '',
      requestLookup: { loading: false, matched: null, error: null },
      requestLookupTimer: null,

      activityTypes: [
        { name: 'Call', icon: 'PhoneIcon' },
        { name: 'Email', icon: 'MailIcon' },
        { name: 'Visit', icon: 'MapPinIcon' },
        { name: 'Meeting', icon: 'UsersIcon' },
        { name: 'Follow-up', icon: 'ClockIcon' }
      ],

      datePresets: [
        { label: 'Today', days: 0 },
        { label: 'Tomorrow', days: 1 },
        { label: '+3 Days', days: 3 },
        { label: '+7 Days', days: 7 }
      ],

      dateConfig: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'M j, Y',
        allowInput: true
      }
    }
  },
  computed: {
    currentActivity() {
      return this.card ? this.card.nextActivity : null
    },
    isEmailCompose() {
      return this.startInEmailMode || !!(this.currentActivity && this.currentActivity.type === 'Email')
    },
    canSendEmail() {
      return this.emailTo.trim() !== '' && this.emailSubject.trim() !== '' && this.emailBody.trim() !== ''
    },
    isLostMove() {
      return this.targetStage === 'lost'
    },
    isWonMove() {
      return this.targetStage === 'won'
    },
    resolvedLostReason() {
      return this.lostReasonSelect === 'Other' ? this.lostReasonOther.trim() : this.lostReasonSelect
    },
    headerIcon() {
      if (this.isLostMove) return 'XCircleIcon'
      if (this.isWonMove) return 'CheckCircleIcon'
      if (this.isEmailCompose) return 'MailIcon'
      return 'CalendarIcon'
    },
    titleText() {
      if (this.isLostMove) return 'Mark Opportunity Lost'
      if (this.isWonMove) return 'Mark Opportunity Won'
      if (this.isEmailCompose) return 'Send Email'
      if (this.targetStage) return 'Complete & Schedule Next Activity'
      return 'Schedule Activity'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.outcomeNote = ''
        this.noNextActivity = false
        this.nextNote = ''

        const suggestion = STAGE_NEXT_ACTIVITY[this.targetStage]
        if (suggestion) {
          this.nextType = suggestion.type
          this.nextNote = suggestion.note
          this.applyDatePreset(suggestion.days)
        } else {
          this.nextType = 'Call'
          this.applyDatePreset(3)
        }

        this.emailTo = (this.card && this.card.email) ? this.card.email : ''
        this.emailCc = ''
        this.emailSubject = this.card ? `${this.card.title || this.card.company || ''} — Follow up` : ''
        this.emailBody = ''
        this.emailAttachments = []
        this.emailSendMode = 'now'
        this.emailSendDate = moment().format('YYYY-MM-DD')
        this.emailSendTime = '09:00'

        this.lostReasonSelect = ''
        this.lostReasonOther = ''
        this.requestCode = ''
        this.requestLookup = { loading: false, matched: null, error: null }
      }
    }
  },
  methods: {
    getActivityIcon(type) {
      const map = { Call: 'PhoneIcon', Email: 'MailIcon', Visit: 'MapPinIcon', Meeting: 'UsersIcon', 'Follow-up': 'ClockIcon' }
      return map[type] || 'CalendarIcon'
    },
    applyDatePreset(days) {
      this.selectedPreset = days
      this.nextDate = moment().add(days, 'days').format('YYYY-MM-DD')
    },
    onFilesSelected(e) {
      this.emailAttachments = this.emailAttachments.concat(Array.from(e.target.files || []))
      e.target.value = ''
    },
    removeAttachment(idx) {
      this.emailAttachments.splice(idx, 1)
    },
    handleSendEmail() {
      if (!this.canSendEmail) return
      const to = this.emailTo.split(',').map(s => s.trim()).filter(Boolean)
      const cc = this.emailCc.split(',').map(s => s.trim()).filter(Boolean)
      const sendAt = this.emailSendMode === 'schedule'
        ? `${this.emailSendDate} ${this.emailSendTime}:00`
        : null

      this.$emit('send-email', {
        to,
        cc,
        subject: this.emailSubject,
        body: this.emailBody,
        sendAt,
        attachments: this.emailAttachments
      })
    },
    onRequestCodeInput() {
      if (this.requestLookupTimer) clearTimeout(this.requestLookupTimer)
      this.requestLookup = { loading: false, matched: null, error: null }
      const code = this.requestCode.trim()
      if (!code) return
      this.requestLookupTimer = setTimeout(() => this.lookupRequest(code), 400)
    },
    async lookupRequest(code) {
      this.requestLookup = { loading: true, matched: null, error: null }
      try {
        const res = await axios.get('crm/requests/lookup', { params: { code } })
        const body = decryptData(res.data.payload)
        this.requestLookup = { loading: false, matched: (body && body.data) || null, error: null }
      } catch (e) {
        this.requestLookup = { loading: false, matched: null, error: 'No request found with that number.' }
      }
    },
    handleSave() {
      if (this.isLostMove) {
        if (!this.resolvedLostReason) return
        this.$emit('submit', {
          outcomeNote: this.outcomeNote,
          nextActivity: null,
          targetStage: 'lost',
          lostReason: this.resolvedLostReason
        })
        return
      }
      if (this.isWonMove) {
        if (!this.requestLookup.matched) return
        this.$emit('submit', {
          outcomeNote: this.outcomeNote,
          nextActivity: null,
          targetStage: 'won',
          requestId: this.requestLookup.matched.id
        })
        return
      }
      this.$emit('submit', {
        outcomeNote: this.outcomeNote,
        nextActivity: this.noNextActivity ? null : {
          type: this.nextType,
          dueDate: this.nextDate,
          time: this.nextTime,
          note: this.nextNote,
          status: 'Pending',
          createdAt: new Date().toISOString()
        },
        targetStage: this.targetStage
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #6366f1;
$primary-dark: #4f46e5;
$success: #10b981;
$warning: #f59e0b;
$slate-50: #f8fafc;
$slate-100: #f1f5f9;
$slate-200: #e2e8f0;
$slate-300: #cbd5e1;
$slate-400: #94a3b8;
$slate-500: #64748b;
$slate-600: #475569;
$slate-700: #334155;
$slate-800: #1e293b;
$slate-900: #0f172a;

.crm-modal-backdrop {
  position: fixed; inset: 0; z-index: 1060;
  display: flex; align-items: center; justify-content: center;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(6px);
}

.crm-modal-card {
  background: #fff; border-radius: 16px;
  width: 520px; max-height: 88vh;
  display: flex; flex-direction: column;
  box-shadow: 0 25px 60px -12px rgba(0,0,0,0.18);
  overflow: hidden;
}

.crm-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 20px 24px; border-bottom: 1px solid $slate-100;

  &__left { display: flex; align-items: center; gap: 10px; }
  &__icon {
    width: 36px; height: 36px; border-radius: 10px;
    background: linear-gradient(135deg, $primary, $primary-dark);
    display: flex; align-items: center; justify-content: center; color: #fff;
  }
  &__title { font-size: 16px; font-weight: 700; color: $slate-900; margin: 0; }
  &__subtitle { font-size: 12.5px; color: $slate-500; margin: 2px 0 0 0; }
}

.crm-modal-close {
  width: 32px; height: 32px; border-radius: 8px; border: none;
  background: $slate-50; color: $slate-400; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  &:hover { background: $slate-100; color: $slate-700; }
}

.crm-modal-body { padding: 20px 24px; overflow-y: auto; flex: 1; }
.crm-modal-footer { padding: 16px 24px; border-top: 1px solid $slate-100; display: flex; justify-content: flex-end; gap: 10px; }

.crm-activity-step {
  &__header { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
}

.crm-step-badge {
  width: 22px; height: 22px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 800; color: #fff;

  &--done { background-color: $success; }
  &--next { background-color: $primary; }
}

.crm-step-title { font-size: 14px; font-weight: 700; color: $slate-900; margin: 0; }

// Karim, 7 Sep: "button for none or no next activity."
.crm-none-btn {
  margin-left: auto; padding: 4px 10px; font-size: 12px; border: 1px solid $slate-300;
  border-radius: 999px; display: inline-flex; align-items: center; gap: 4px;

  &--active { background-color: $slate-800; border-color: $slate-800; color: #fff; }
}

.crm-field-hint {
  font-size: 12px; color: $slate-500; background: $slate-50; border: 1px dashed $slate-300;
  border-radius: 8px; padding: 10px 12px; margin: 0;

  &--tight { background: none; border: none; padding: 4px 0 0; }
  &--ok { color: $success; }
  &--error { color: #ef4444; }
}

.crm-type-grid {
  display: grid; grid-template-columns: repeat(5, 1fr); gap: 6px;
}

.crm-type-btn {
  display: flex; flex-direction: column; align-items: center; gap: 4px;
  padding: 8px 4px; border: 1.5px solid $slate-200; border-radius: 8px;
  background: #fff; font-size: 11px; font-weight: 600; color: $slate-600;
  cursor: pointer; transition: all 0.15s ease;

  &:hover { border-color: $primary; color: $primary; }

  &--active {
    border-color: $primary; background: rgba($primary, 0.08); color: $primary;
    box-shadow: 0 0 0 2px rgba($primary, 0.2);
  }
}

.crm-preset-btn {
  padding: 5px 10px; border: 1px solid $slate-200; border-radius: 6px;
  background: $slate-50; font-size: 12px; font-weight: 600; color: $slate-600;
  cursor: pointer; transition: all 0.15s ease;
  display: inline-flex; align-items: center;

  &:hover { border-color: $slate-300; background: #fff; }
  &--active { background: $slate-900; color: #fff; border-color: $slate-900; }
}

.crm-form-group { margin-bottom: 14px; }
.crm-form-row { display: flex; gap: 10px; }
.crm-form-label { display: block; font-size: 11.5px; font-weight: 700; color: $slate-500; text-transform: uppercase; margin-bottom: 4px; }
.crm-input { width: 100%; border: 1.5px solid $slate-200; border-radius: 8px; padding: 8px 10px; font-size: 13px; color: $slate-700; }
.crm-textarea { width: 100%; border: 1.5px solid $slate-200; border-radius: 8px; padding: 8px 10px; font-size: 13px; color: $slate-700; }

.crm-btn {
  font-size: 13px; font-weight: 600; padding: 8px 16px; border-radius: 8px; border: none; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;
  &--ghost { background: $slate-50; color: $slate-600; border: 1px solid $slate-200; }
  &--primary { background: linear-gradient(135deg, $primary, $primary-dark); color: #fff; }
  &--danger { background: #ef4444; color: #fff; }
  &--primary:disabled, &--danger:disabled { opacity: 0.5; cursor: not-allowed; }
}

.crm-attach-list { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }
.crm-attach-chip {
  display: inline-flex; align-items: center; gap: 4px;
  background: $slate-50; border: 1px solid $slate-200; border-radius: 999px;
  padding: 3px 8px 3px 10px; font-size: 11.5px; color: $slate-700; max-width: 220px;

  &__remove {
    border: none; background: none; color: $slate-400; cursor: pointer;
    display: flex; align-items: center; padding: 2px;
    &:hover { color: $slate-700; }
  }
}
.crm-attach-btn { cursor: pointer; }

.gap-2 { gap: 0.5rem; }
</style>
